// import config from "./config";
import Firebase from "firebase/app";
import "firebase/database";

let firebaseApp;
if (!Firebase.apps.length) {
  firebaseApp = Firebase.initializeApp({
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: "happy-belated-treatmas-2019.firebaseapp.com",
    databaseURL: "happy-belated-treatmas-2019.firebaseio.com",
    projectId: process.env.FIREBASE_PROJECT_ID
  });
} else {
  firebaseApp = Firebase.app();
}

let db = firebaseApp.database();

export default db;
